import { useEffect, useState } from 'react';

import { useCustomizationsGroupsLang } from './useCustomizationsGroupsLang';

import type { MouseEvent } from 'react';
import type { ProductId } from 'shared/domain';
import type { FullMenuCatalog } from 'features/menu-page/domain';

export function useCustomizationsGroups(props: Props) {
  const { catalog, productId } = props;

  const hasProductId = !isNaN(productId);

  const customGroupsToRender = hasProductId
    ? catalog.customizationGroups.filter(cg => cg.productId === productId)
    : [...new Map(catalog.customizationGroups.map(cg => [cg.id, cg])).values()];

  const [collapse, setCollapse] = useState(NaN);

  const lang = useCustomizationsGroupsLang();

  const handleClickCollapse = (e: MouseEvent<HTMLButtonElement>) => {
    const customGroupId = Number(e.currentTarget.dataset.customGroupId);
    setCollapse(customGroupId === collapse ? NaN : customGroupId);
  };

  useEffect(() => {
    if (customGroupsToRender.length === 1) {
      setCollapse(customGroupsToRender[0].id);
    }
  }, [customGroupsToRender]);

  return {
    lang,
    collapse,
    hasProductId,
    customGroupsToRender,
    handleClickCollapse,
  };
}

interface Props {
  catalog: FullMenuCatalog;
  productId: ProductId;
}
